import * as Types from '../../../../../__generated__/schema';

import { UserDetails } from '../../../../graphql/fragments/UserDetails.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InviteUserVariables = Types.Exact<{
  input: Types.InviteUserInput;
}>;

export type InviteUser = { inviteUser: { user: UserDetails } };

export const InviteUserDocument = gql`
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input) {
      user {
        ...UserDetails
      }
    }
  }
  ${UserDetails}
`;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUser, InviteUserVariables>;

/**
 * __useInviteUser__
 *
 * To run a mutation, you first call `useInviteUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUser, { data, loading, error }] = useInviteUser({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUser(
  baseOptions?: Apollo.MutationHookOptions<InviteUser, InviteUserVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InviteUser, InviteUserVariables>(InviteUserDocument, options);
}
export type InviteUserHookResult = ReturnType<typeof useInviteUser>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUser>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUser, InviteUserVariables>;
export function mockInviteUser({
  data,
  variables,
  errors,
}: {
  data: InviteUser;
  variables?: InviteUserVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: InviteUserDocument, variables },
    result: { data, errors },
  };
}
